module.exports = "<p>\n  contract works!\n</p>\n"